// Japanese translations
export const ja = {
  // Header
  header: {
    title: 'MicroGPT ラボ',
    subtitle: 'microgpt をインタラクティブに学ぶ',
    level: 'レベル',
    params: 'パラメータ',
    badges: 'バッジ',
    train: 'トレーニング',
    star: 'スター'
  },

  // Navigation
  nav: {
    curriculum: 'カリキュラム',
    content: 'コンテンツ',
    visualization: 'ビジュアライゼーション'
  },

  // Levels
  levels: {
    completed: '完了',
    locked: 'ロック中',
    current: '現在のレベル'
  },

  // Buttons
  buttons: {
    complete: 'レベルを完了',
    startLearning: '学習を開始',
    trainAgain: '再トレーニング',
    reset: 'リセット',
    close: '閉じる',
    cancel: 'キャンセル',
    confirm: 'OK',
    showHint: 'ヒントを表示',
    showSolution: '解答を表示',
    runCheck: '実行して確認',
    randomize: 'ランダム化'
  },

  // Training Experience
  training: {
    title: 'MicroGPT をトレーニング',
    intro: '言語モデルのトレーニングとテキスト生成をリアルタイムで観察',
    starting: 'トレーニング開始中...',
    training: 'トレーニング中...',
    generating: 'サンプル生成中...',
    complete: 'トレーニング完了！',
    lossLabel: '損失',
    stepLabel: 'ステップ',
    generatedNames: '生成された名前（幻覚生成！）',
    explanation: 'これらの名前はモデルが幻覚生成したものです - 一度も見たことがありません！',
    pipeline: '完全な MicroGPT パイプライン',
    comparison: 'このデモから ChatGPT へ',
    thisDemo: 'このデモ',
    chatgpt: 'ChatGPT',
    sameAlgorithm: '同じアルゴリズム、異なるスケール！'
  },

  // About Dialog
  about: {
    title: 'MicroGPT について',
    subtitle: '大規模言語モデルの本質',
    whatIs: 'MicroGPT とは？',
    whatIsDesc: 'MicroGPT は GPT スタイルの言語モデルの最小実装です...',
    whatYoullLearn: '学べること',
    fromMicroToMega: 'マイクロからメガへ',
    chatgptConnection: 'ChatGPT との関連',
    resources: 'リソース',
    resetProgress: 'すべての進捗をリセット',
    resetProgressDesc: '完了したレベルと獲得したバッジをすべてクリア',
    resetConfirm: 'すべての進捗をリセットしてもよろしいですか？完了したレベルと獲得したバッジがクリアされます。'
  },

  // Code Exercise
  exercise: {
    description: '説明',
    template: 'コードテンプレート',
    hint: 'ヒント',
    solution: '解答',
    useSolution: 'この解答を使用',
    attempts: '回の試行',
    attemptsPlural: '回の試行',
    checking: '確認中...',
    loading: 'Python 環境を読み込み中...',
    testPassed: 'テスト合格',
    testFailed: 'テスト不合格',
    allTestsPassed: 'すべてのテストに合格！',
    someTestsFailed: '一部のテストが不合格',
    tabSpaces: 'Tab = 4 スペース'
  },

  // Notifications
  notifications: {
    badgeEarned: 'バッジ獲得',
    levelComplete: 'レベル完了！',
    readyToLearn: '仕組みを学ぶ準備ができました！'
  },

  // Theme
  theme: {
    chooseTheme: 'テーマを選択',
    selectScheme: '好みの配色を選択してください',
    dark: 'ダーク',
    light: 'ライト'
  },

  // Common
  common: {
    loading: '読み込み中...',
    error: 'エラー',
    success: '成功',
    warning: '警告',
    info: '情報'
  }
};
